import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const faDroplet: IconDefinition = {
  prefix: "fas",
  iconName: "droplet",
  icon: [384, 512, [], "f043", "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0l1.8 0c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"],
};

export default faDroplet;
